<template>
  <BasePopover
    v-model="open"
    class="m-help"
    :popper-class="['m-help__popper', popperClass]"
    :placement="placement"
    :options="popperOptions"
    :visible-arrow="visibleArrow"
    :reference-selector="referenceSelector"
    :show-on="showOn"
    offset="0,5"
  >
    <template slot="popper">
      <div
        class="m-help__content"
        :style="{ width }"
      >
        <slot />
        <slot name="content" />
      </div>
    </template>
    <template slot="reference">
      <MIcon
        v-if="!customReference"
        v-bind="$attrs"
        class="m-help__icon"
        :class="{ 'm-help__icon_active': open }"
        :icon="helpIcon"
      />
      <slot name="reference" />
    </template>
  </BasePopover>
</template>

<script>
  import BasePopover from 'components/common/BasePopover';
  import helpIcon from 'assets/icons/help.svg';
  import MIcon from 'components/Design/MIcon';

  export default {
    name: 'MHelp',
    components: {BasePopover, MIcon},
    inheritAttrs: false,
    props: {
      placement: {
        type: BasePopover.props.placement.type,
        required: BasePopover.props.placement.required,
        default: BasePopover.props.placement.default
      },
      width: {
        type: String,
        required: true
      },
      popperClass: {
        type: BasePopover.props.popperClass.type,
        default: BasePopover.props.popperClass.default
      },
      popperOptions: {
        type: Object,
        default: Object
      },
      visibleArrow: {
        type: Boolean,
        default: true
      },
      customReference: {
        type: Boolean,
        default: false
      },
      referenceSelector: {
        type: String,
        default: null
      },
      showOn: {
        type: BasePopover.props.showOn.type,
        default: BasePopover.props.showOn.default,
        choices: BasePopover.props.showOn.choices
      }
    },
    data () {
      return {
        open: false,
        helpIcon
      };
    },
    beforeDestroy () {
      this.open = false;
    }
  };
</script>

<style>
  .m-help {
    cursor: pointer;

    width: 14px;
    height: 14px;
  }

  .m-help__popper {
    z-index: 10000;
  }

  .m-help__content {
    font-size: 12px;

    color: var(--secondary-text-color);

    box-sizing: border-box;

    padding: 12px;
  }

  .m-help__icon {
    color: var(--panel-text-color);

    width: 14px;
    height: 14px;
  }

  .m-help__icon:hover,
  .m-help__icon_active {
    color: var(--action-color);
  }
</style>
